import { Box, Stack, Typography, useTheme } from "@mui/material";
import { sectionIds } from "../../const/course";
import type { CourseDetailsPageData } from "../../hook/useCourseDetailsPageData";
import { getSectionTitle, getSharingEmbedUrl, getSharingPreviewImage } from "../../util/course";
import { getCourseGlassSurfaceSx } from "./const/surface";
import MediaTile from "./MediaTile";
import RevealSection from "./RevealSection";
import SectionShell from "./SectionShell";

export type DescriptionSectionProps = Readonly<{
  data: CourseDetailsPageData;
}>;

export default function DescriptionSection({ data }: DescriptionSectionProps) {
  const theme = useTheme();
  const featuredSharing = data.featuredSharing;
  const hasFeaturedSharing = featuredSharing != null;

  return (
    <RevealSection>
      <SectionShell id="description" title={getSectionTitle(data.pageMap, sectionIds.description)}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: hasFeaturedSharing ? { xs: "1fr", lg: "minmax(0, 7fr) minmax(0, 5fr)" } : "1fr",
            gap: { xs: 3, md: 4 },
          }}
        >
          <Stack
            spacing={2.5}
            sx={{
              p: { xs: 3, md: 4 },
              ...getCourseGlassSurfaceSx(theme),
            }}
          >
            {data.descriptionContent.paragraphs.map((paragraph) => (
              <Typography key={paragraph} variant="body1" color="primary.contrastText">
                {paragraph}
              </Typography>
            ))}
          </Stack>

          {!featuredSharing ? null : (
            <MediaTile
              title={featuredSharing.title}
              thumbnailImage={getSharingPreviewImage(featuredSharing, data.heroImage)}
              isVideo
              embedUrl={getSharingEmbedUrl(featuredSharing)}
              isPlaying={data.playingVideoId === featuredSharing.id}
              onPlayToggle={() => data.togglePlayingVideo(featuredSharing.id)}
              actionLabel="播放影片"
              onAction={() => data.togglePlayingVideo(featuredSharing.id)}
            />
          )}
        </Box>
      </SectionShell>
    </RevealSection>
  );
}
